module.exports = __webpack_public_path__ + "img/Iconen Class Action website-03.f8d1a410.svg";